(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayla-product-footer"] && !Shopify.designMode) return;
  try {
    
  (function() {

// Keep the Human Grade badge from overlapping the protein pill by nudging it left when needed.
    const CARD_SELECTOR = '.ayla-product-footer .benefits-card';
    const COLLISION_MARGIN = 12;
    let frameId = null;

    function clamp(value, min) {
      return value < min
        ? min
        : value;
    }

    function updateCard(card) {
      const humanBadge = card.querySelector('.benefits-human-grade');
      const proteinPill = card.querySelector('.protein-pill');

      if (! humanBadge || ! proteinPill) {
        return;
      }

// Reset to stylesheet positioning to read the current breakpoint defaults
      humanBadge.style.left = '';
      const baseLeft = parseFloat(window.getComputedStyle(humanBadge).left) || 0;
      humanBadge.style.left = baseLeft + 'px';

      const cardRect = card.getBoundingClientRect();
      const humanRect = humanBadge.getBoundingClientRect();
      const proteinRect = proteinPill.getBoundingClientRect();

      const shouldAdjust = humanRect.right > (proteinRect.left - COLLISION_MARGIN);
      if (! shouldAdjust) {
        humanBadge.style.left = '';
        return;
      }

      const availableRightEdge = proteinRect.left - cardRect.left - COLLISION_MARGIN;
      const adjustedLeft = clamp(availableRightEdge - humanRect.width, 16);

      if (Math.abs(adjustedLeft - baseLeft) <= 0.5) {
        humanBadge.style.left = '';
        return;
      }

      humanBadge.style.left = adjustedLeft + 'px';
    }

    function updateAll(root) {
      const scope = root || document;
      scope.querySelectorAll(CARD_SELECTOR).forEach(updateCard);
    }

    function scheduleUpdate(root) {
      if (frameId) {
        return;
      }
      frameId = window.requestAnimationFrame(function() {
        frameId = null;
        updateAll(root);
      });
    }

    function init(root) {
      updateAll(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init();
      });
    } else {
      init();
    }

    window.addEventListener('resize', function() {
      scheduleUpdate();
    });

    window.addEventListener('load', function() {
      scheduleUpdate();
    });

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:reorder', function() {
      scheduleUpdate();
    });

    document.addEventListener('shopify:section:select', function(event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:deselect', function() {
      scheduleUpdate();
    });
  })();

  // Center product grid when there are exactly 2 products (fallback for browsers without :has() support)
  (function() {
    function updateProductGrid() {
      const grids = document.querySelectorAll('.delight-product-section__grid');
      grids.forEach(function(grid) {
        const tiles = grid.querySelectorAll('.delight-product-tile');
        if (tiles.length === 2) {
          grid.classList.add('delight-product-section__grid--two-items');
        } else {
          grid.classList.remove('delight-product-section__grid--two-items');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateProductGrid);
    } else {
      updateProductGrid();
    }

    document.addEventListener('shopify:section:load', function(event) {
      updateProductGrid();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayla-product-lines"] && !Shopify.designMode) return;
  try {
    
  class AylaProductLines extends HTMLElement {
    constructor() {
      super();
      ('[AylaProductLines] New image-based layout initialized');
    }

    connectedCallback() {

// New image-based layout - no background switching needed
      ('[AylaProductLines] Connected with new image layout');
    }
  }

  customElements.define('ayla-product-lines', AylaProductLines);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-ayla"] && !Shopify.designMode) return;
  try {
    
  // Ensure contact button works reliably on mobile devices
  (function() {
    function initContactButton() {
      const contactButton = document.querySelector('.contact-button');
      if (!contactButton) return;

      // Ensure the link element has proper attributes
      contactButton.setAttribute('role', 'button');
      contactButton.setAttribute('aria-label', contactButton.textContent.trim() || 'Contact us');

      // Add click handler as fallback for mobile
      contactButton.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href) {
          // Allow default behavior first, but ensure navigation happens
          // This helps with mobile browsers that might not handle links properly
          const currentHref = window.location.href;
          setTimeout(function() {
            // If navigation didn't happen, force it
            if (window.location.href === currentHref && !currentHref.includes('kontakt')) {
              window.location.href = href;
            }
          }, 50);
        }
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactButton);
    } else {
      initContactButton();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ayla-delight"] && !Shopify.designMode) return;
  try {
    
  // Immediate syntax validation
  try {
    console.log('[Hero] JavaScript starting - syntax validation passed');
  } catch (e) {
    console.error('[Hero] Syntax error detected:', e);
    return;
  }

// Ensure DOM is ready before defining custom element
  function initHeroCustomElement() {
    class HeroAylaDelight extends HTMLElement {
      constructor() {
        super();
        this.dataset.heroController = 'custom-element';
        this.currentSlide = 0;
        this.slides = [];
        this.autoPlayInterval = null;
        this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
        this.autoPlayDelay = parseInt(this.dataset.autoplayDelay) * 1000 || 5000;
        this.progressAnimationFrame = null;
        this.progressStartTime = null;
        this.progressPausedTime = null;
        this.progressPausedWidth = null;
      }

      connectedCallback() {

// Use requestAnimationFrame to ensure DOM is fully ready
        requestAnimationFrame(() => {
          this.init();
        });
      }

      disconnectedCallback() {
        this.stopAutoPlay();
      }

      init() {
        this.slides = this.querySelectorAll('.hero-slide');
        this.totalSlides = parseInt(this.dataset.totalSlides) || this.slides.length;
        
        // Try to restore saved slide index from data attribute first (survives reloads)
        // Then try sessionStorage, then detect from DOM
        let savedSlideIndex = null;
        
        // Check data attribute first (set before reload)
        if (this.dataset.currentSlideIndex) {
          const dataIndex = parseInt(this.dataset.currentSlideIndex);
          if (!isNaN(dataIndex) && dataIndex >= 0 && dataIndex < this.slides.length) {
            savedSlideIndex = dataIndex;
          }
        }
        
        // Fallback to sessionStorage
        if (savedSlideIndex === null) {
          try {
            const saved = sessionStorage.getItem('hero-ayla-delight-current-slide');
            if (saved !== null) {
              savedSlideIndex = parseInt(saved);
              // Validate the saved index is valid
              if (isNaN(savedSlideIndex) || savedSlideIndex < 0 || savedSlideIndex >= this.slides.length) {
                savedSlideIndex = null;
              }
            }
          } catch (e) {
            // sessionStorage might not be available, ignore
          }
        }

        const wakacjeIsFirstSlide = this.slides[0] && this.slides[0].classList.contains('hero-slide--wakacje');
        if (wakacjeIsFirstSlide && savedSlideIndex !== null && savedSlideIndex !== 0) {
          savedSlideIndex = null;
        }
        
        // Detect current active slide from DOM
        const activeSlideIndex = Array.from(this.slides).findIndex(slide => 
          slide.classList.contains('active')
        );
        
        // Use saved index if available, otherwise use DOM state, otherwise default to 0
        if (savedSlideIndex !== null) {
          this.currentSlide = savedSlideIndex;
          // Ensure the saved slide is active
          this.slides.forEach((slide, index) => {
            slide.classList.toggle('active', index === savedSlideIndex);
          });
          // Clear the saved values after using them
          delete this.dataset.currentSlideIndex;
          try {
            sessionStorage.removeItem('hero-ayla-delight-current-slide');
          } catch (e) {}
        } else if (activeSlideIndex !== -1) {
          this.currentSlide = activeSlideIndex;
        } else {
          // Fallback: if no slide is active, activate the first one
          this.currentSlide = 0;
          if (this.slides[0]) {
            this.slides[0].classList.add('active');
          }
        }
        
        this.resetProgressFills();

// Check if navigation container exists
        const navigationContainer = this.querySelector('.hero-slide-navigation');

// Check slides in DOM
        const prevButton = this.querySelector('.nav-prev');
        const nextButton = this.querySelector('.nav-next');

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            this.stopAutoPlay();
            this.previousSlide();
            // Re-check autoplay setting dynamically
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            if (this.autoPlayEnabled) 
              this.startAutoPlay();
            


          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            this.stopAutoPlay();
            this.nextSlide();
            // Re-check autoplay setting dynamically
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            if (this.autoPlayEnabled) 
              this.startAutoPlay();
            


          });
        }

        this.updateProgress();

        // Always re-check autoplay setting before starting
        this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
        if (this.autoPlayEnabled && this.totalSlides > 1) {
          this.startAutoPlay();
          this.restartProgressAnimation();
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            this.stopAutoPlay();
            this.previousSlide();
            // Re-check autoplay setting dynamically
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            if (this.autoPlayEnabled) 
              this.startAutoPlay();
            


          } else if (e.key === 'ArrowRight') {
            this.stopAutoPlay();
            this.nextSlide();
            // Re-check autoplay setting dynamically
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            if (this.autoPlayEnabled) 
              this.startAutoPlay();
            


          }
        });

        if (this.autoPlayEnabled) {
          this.addEventListener('mouseenter', () => {
            this.pauseProgressAnimation();
            // Manually clear interval without calling stopAutoPlay which resets state
            if (this.autoPlayInterval) {
              clearInterval(this.autoPlayInterval);
              this.autoPlayInterval = null;
            }
          });
          this.addEventListener('mouseleave', () => {
            // Re-check autoplay setting dynamically
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            if (this.autoPlayEnabled && this.totalSlides > 1) {
              const isResuming = this.progressPausedWidth !== null;
              this.resumeProgressAnimation();
              // Only start auto-play if not resuming - animation completion will handle resume case
              if (!isResuming) {
                this.startAutoPlay();
              }
            }
          });
        }

        // Listen for Shopify theme editor section updates
        // Save slide index BEFORE section reloads
        document.addEventListener('shopify:section:select', () => {
          // Save current slide before any potential reload
          const currentActiveSlide = Array.from(this.slides).findIndex(slide => 
            slide.classList.contains('active')
          );
          if (currentActiveSlide !== -1) {
            this.dataset.currentSlideIndex = currentActiveSlide.toString();
            try {
              sessionStorage.setItem('hero-ayla-delight-current-slide', currentActiveSlide.toString());
            } catch (e) {}
          }
        });
        
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail && event.detail.sectionId) {
            // Re-read autoplay setting when section is reloaded
            this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
            
            // Restore slide from saved index (set in init or from previous state)
            // The init() method already handles restoration, but ensure it's applied
            const activeSlideIndex = Array.from(this.slides).findIndex(slide => 
              slide.classList.contains('active')
            );
            
            // If DOM shows first slide but we have a saved index, restore it
            if (activeSlideIndex === 0 && this.currentSlide !== 0 && this.slides[this.currentSlide]) {
              this.slides[0].classList.remove('active');
              this.slides[this.currentSlide].classList.add('active');
              this.updateProgress();
            } else if (activeSlideIndex !== -1 && activeSlideIndex !== this.currentSlide) {
              this.currentSlide = activeSlideIndex;
            }
            
            this.stopAutoPlay();
            this.updateProgress();
            
            if (this.autoPlayEnabled && this.totalSlides > 1) {
              this.startAutoPlay();
              this.restartProgressAnimation();
            }
          }
        });

        // Watch for data attribute changes (for live editor updates)
        const autoplayObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-autoplay-enabled') {
              const newValue = this.dataset.autoplayEnabled === 'true';
              if (this.autoPlayEnabled !== newValue) {
                // Save current slide index to both sessionStorage and data attribute
                // This persists across section reloads
                const currentActiveSlide = Array.from(this.slides).findIndex(slide => 
                  slide.classList.contains('active')
                );
                const slideToPreserve = currentActiveSlide !== -1 ? currentActiveSlide : this.currentSlide;
                
                // Store in data attribute (survives section reload)
                this.dataset.currentSlideIndex = slideToPreserve.toString();
                
                try {
                  sessionStorage.setItem('hero-ayla-delight-current-slide', slideToPreserve.toString());
                } catch (e) {
                  // sessionStorage might not be available, ignore
                }
                
                this.autoPlayEnabled = newValue;
                this.stopAutoPlay();
                
                // Restore the current slide immediately if needed
                if (slideToPreserve !== this.currentSlide && this.slides[slideToPreserve]) {
                  this.currentSlide = slideToPreserve;
                  this.slides.forEach((slide, index) => {
                    slide.classList.toggle('active', index === slideToPreserve);
                  });
                  this.updateProgress();
                }
                
                if (this.autoPlayEnabled && this.totalSlides > 1) {
                  this.startAutoPlay();
                  this.restartProgressAnimation();
                }
              }
            }
          });
        });

        autoplayObserver.observe(this, {
          attributes: true,
          attributeFilter: ['data-autoplay-enabled']
        });
      }

      previousSlide() {
        this.changeSlide(
          this.currentSlide > 0
            ? this.currentSlide - 1
            : this.totalSlides - 1
        );
      }

      nextSlide() {
        this.changeSlide(this.currentSlide<this.totalSlides - 1 ? this.currentSlide + 1 : 0);
      }

      changeSlide(newIndex) {
        if (this.slides[this.currentSlide]) {
          this.slides[this.currentSlide].classList.remove('active');
        }

        this.currentSlide = newIndex;
        
        // Save current slide index to both data attribute and sessionStorage
        // Data attribute survives section reloads better
        this.dataset.currentSlideIndex = this.currentSlide.toString();
        try {
          sessionStorage.setItem('hero-ayla-delight-current-slide', this.currentSlide.toString());
        } catch (e) {
          // sessionStorage might not be available, ignore
        }

        var currentSlideEl = this.slides[this.currentSlide];
        if (currentSlideEl) {
          currentSlideEl.classList.add('active');

          var nextIndex = (this.currentSlide + 1) % this.totalSlides;
          var nextSlideEl = this.slides[nextIndex];
          if (nextSlideEl) {
            var nextImage = nextSlideEl.querySelector('img[loading="lazy"]');
            if (nextImage && !nextImage.complete) {
              nextImage.loading = 'eager';
            }
          }
        }

        this.updateProgress();
        this.restartProgressAnimation();
      }

      updateProgress() {
        var dots = this.querySelectorAll('.progress-dot');
        var totalDots = dots.length || 1;
        var normalizedIndex = ((this.currentSlide % totalDots) + totalDots) % totalDots;

        Array.prototype.forEach.call(dots, function(dot, index) {
          var isActive = index === normalizedIndex;
          dot.classList.toggle('active', isActive);

          var fill = dot.querySelector('.progress-fill');
          if (fill) {
            fill.style.width = '0px';
          }
        });
      }

      resetProgressFills() {
        const fills = this.querySelectorAll('.progress-fill');
        fills.forEach((fill) => {
          fill.style.display = '';
          fill.style.width = '0px';
        });
      }

      stopProgressAnimation() {
        if (this.progressAnimationFrame) {
          cancelAnimationFrame(this.progressAnimationFrame);
          this.progressAnimationFrame = null;
        }
        this.progressStartTime = null;
        // Don't clear progressPausedWidth here - it should only be cleared when restarting
        // (e.g., when changing slides), not when pausing/resuming
      }

      pauseProgressAnimation() {
        if (this.progressAnimationFrame) {
          cancelAnimationFrame(this.progressAnimationFrame);
          this.progressAnimationFrame = null;
        }
        
        // Always save current progress state (even if animation wasn't running)
        const activeDot = this.querySelector('.progress-dot.active');
        if (activeDot) {
          const progressFill = activeDot.querySelector('.progress-fill');
          if (progressFill) {
            // Get actual rendered width (from style or computed)
            const styleWidth = parseFloat(progressFill.style.width);
            const computedWidth = parseFloat(window.getComputedStyle(progressFill).width);
            const currentWidth = styleWidth || computedWidth || 0;
            
            this.progressPausedWidth = currentWidth;
            this.progressPausedTime = Date.now();
          }
        }
      }

      resumeProgressAnimation() {
        if (!this.autoPlayEnabled || this.totalSlides<= 1) {
          this.resetProgressFills();
          return;
        }

        // Stop any existing animation before starting a new one
        this.stopProgressAnimation();

        const activeDot = this.querySelector('.progress-dot.active');
        if (!activeDot) {
          return;
        }

        const progressFill = activeDot.querySelector('.progress-fill');
        if (!progressFill) {
          return;
        }

        progressFill.style.display = '';
        
        const computedWidth = parseFloat(window.getComputedStyle(activeDot).width || '0');
        const fallbackWidth = activeDot.getBoundingClientRect().width;
        const targetWidth = computedWidth || fallbackWidth || 56;
        const duration = this.autoPlayDelay;
        
        // Check if we're resuming from a pause
        let elapsed = 0;
        let startWidth = 0;
        
        if (this.progressPausedWidth !== null) {
          startWidth = this.progressPausedWidth;
          // Protect against 0 width
          if (targetWidth > 0) {
            const progressRatio = startWidth / targetWidth;
            elapsed = progressRatio * duration;
          }
        }
        
        progressFill.style.width = startWidth + 'px';
        
        const startTime = performance.now() - elapsed;

        const step = (now) => {
          const currentElapsed = now - startTime;
          const progress = Math.min(currentElapsed / duration, 1);
          const liveWidth = activeDot.getBoundingClientRect().width || targetWidth;
          progressFill.style.width = `${progress * liveWidth}px`;

          if (progress < 1) {
            this.progressAnimationFrame = requestAnimationFrame(step);
          } else {
            this.progressAnimationFrame = null;
            this.progressStartTime = null;
            this.progressPausedTime = null;
            this.progressPausedWidth = null;
            
            // When animation completes, trigger slide change immediately
            // Clear any existing interval first
            if (this.autoPlayInterval) {
              clearInterval(this.autoPlayInterval);
              this.autoPlayInterval = null;
            }
            // Trigger slide change and restart auto-play
            if (this.autoPlayEnabled && this.totalSlides > 1) {
              this.nextSlide();
              this.startAutoPlay();
            }
          }
        };

        this.progressStartTime = startTime;
        this.progressAnimationFrame = requestAnimationFrame(step);
      }

      restartProgressAnimation() {
        // Clear paused state when restarting (for slide changes)
        this.progressPausedWidth = null;
        this.progressPausedTime = null;
        this.stopProgressAnimation();
        this.resumeProgressAnimation();
      }

      startAutoPlay() {
        // Always re-check the data attribute to get latest setting
        this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
        if (!this.autoPlayEnabled || this.totalSlides<= 1) {
          return;
        }

        if (this.autoPlayInterval) {
          clearInterval(this.autoPlayInterval);
        }

        this.autoPlayInterval = setInterval(() => {
          // Re-check before each slide change
          this.autoPlayEnabled = this.dataset.autoplayEnabled === 'true';
          if (this.autoPlayEnabled) {
            this.nextSlide();
          } else {
            this.stopAutoPlay();
          }
        }, this.autoPlayDelay) 


        


      }

      stopAutoPlay() {
        if (this.autoPlayInterval) {
          clearInterval(this.autoPlayInterval);
          this.autoPlayInterval = null;
        }

        this.stopProgressAnimation();
      }
    }

// Check if hero element exists in DOM
    const heroElements = document.querySelectorAll('hero-ayla-delight');

// Ensure custom element is defined
    if (!customElements.get('hero-ayla-delight')) {
      customElements.define('hero-ayla-delight', HeroAylaDelight);
    }
  }

// Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHeroCustomElement();
    });
  } else {
    initHeroCustomElement();
  }

// Simple direct approach - works without custom elements
  function initHeroNavigation() {
    ('[Hero] Simple navigation initializer starting');

    const heroSection = document.querySelector('hero-ayla-delight') || document.querySelector('.hero-ayla-delight');
    if (! heroSection) {
      ('[Hero] No hero section found');
      return;
    }

    if (heroSection.dataset && heroSection.dataset.heroController === 'custom-element') {
      ('[Hero] Custom element active, skipping simple navigation init');
      return;
    }

    const slides = heroSection.querySelectorAll('.hero-slide');
    const prevButton = heroSection.querySelector('.nav-prev');
    const nextButton = heroSection.querySelector('.nav-next');

    ('[Hero] Simple init found:', {
      slides: slides.length,
      prevButton: !! prevButton,
      nextButton: !! nextButton
    });

    if (slides.length<= 1) {
    ('[Hero] Only one slide, navigation not needed');
    return;
  }

  let currentSlide = 0;

  function changeSlide(newIndex) {
    ('[Hero] Simple: Changing slide from', currentSlide, 'to', newIndex);

    // Remove active class from current slide
    slides[currentSlide]?.classList.remove('active');

    // Add active class to new slide
    currentSlide = newIndex;
    slides[currentSlide]?.classList.add('active');

    // Update progress indicators
    updateProgress();
  }

  function updateProgress() {
    const dots = heroSection.querySelectorAll('.progress-dot');
    const totalDots = dots.length || 1;
    const normalizedIndex = ((currentSlide % totalDots) + totalDots) % totalDots;

    dots.forEach((dot, index) => {
      const isActive = index === normalizedIndex;
      dot.classList.toggle('active', isActive);

      const fill = dot.querySelector('.progress-fill');
      if (fill) {
        fill.style.width = '0px';
      }
    }) 


    


  }

  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      ('[Hero] Simple: Previous button clicked');
      e.preventDefault();
      const newIndex = currentSlide > 0
        ? currentSlide - 1
        : slides.length - 1;
      changeSlide(newIndex);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      ('[Hero] Simple: Next button clicked');
      e.preventDefault();
      const newIndex = currentSlide < slides.length - 1
        ? currentSlide + 1
        : 0;
      changeSlide(newIndex);
    });
  }

  ('[Hero] Simple navigation initialized successfully');
}

// Initialize simple navigation after a short delay
setTimeout(initHeroNavigation, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionManager {
        constructor(element) {
          this.element = element;
          this.paginationHiddenClass = 'paginated-out';
          this.promoSuppressedClass = 'promo-disabled';
          this.filters = {
            categories: [],
            forWhom: [],
            productLine: [],
            meatType: []
          };
          this.userHasInteracted = false;
          this.categoryFilters = ['bestseller', 'new', 'promotion'];
          this.audienceFilters = ['for-cat', 'for-dog'];
          this.meatFilters = ['duck', 'chicken', 'turkey', 'blend'];
          this.collectionHandle = (element.dataset.collectionHandle || '').toLowerCase();
          this.collectionLocaleMap = this.parseCollectionLocaleMap(element.dataset.collectionLocaleMap);
          this.initialFilters = this.parseFiltersFromURL();
          if (this.initialFilters.categories && this.initialFilters.categories.length > 0) {
            this.filters.categories = [...this.initialFilters.categories];
          }
          if (this.initialFilters.forWhom.length > 0) {
            this.filters.forWhom = [...this.initialFilters.forWhom];
          }

    // Sanitize URL-derived meat filters against supported values to avoid hidden/unsupported state
          if (this.initialFilters.meatType.length > 0) {
            const allowedMeat = this.initialFilters.meatType.filter((m) => this.meatFilters.includes(m));
            if (allowedMeat.length > 0) {
              this.filters.meatType = allowedMeat;
            }
          }
          if (this.initialFilters.productLine && this.initialFilters.productLine.length > 0) {
            this.filters.productLine = [...this.initialFilters.productLine];
          }
          this.hasInitialFilters = ((this.initialFilters.categories && this.initialFilters.categories.length > 0) || (this.initialFilters.forWhom && this.initialFilters.forWhom.length > 0) || (this.initialFilters.meatType && this.initialFilters.meatType.length > 0) || (this.initialFilters.productLine && this.initialFilters.productLine.length > 0));
          this.itemsPerPage = this.parseNumber(element.dataset.itemsPerPage, 12);
          this.totalPages = this.parseNumber(element.dataset.totalPages, 1);
          const promoEnabledAttr = (element.dataset.promoEnabled || '').toLowerCase();
          this.isPromoFeatureEnabled = promoEnabledAttr === ''
            ? true
            : promoEnabledAttr === 'true';
          this.sectionId = element.dataset.sectionId || '';
          this.currentPage = this.getInitialPage();
          this.pagesLoaded = new Set([this.currentPage]);
          this.isPromoVisibleOnFirstPage = false;
          this.resizeRaf = null;
          this.handleResize = this.handleResize.bind(this);
          this.isMobileFiltersOpen = false;
          this.handleMobileFilterKeydown = this.handleMobileFilterKeydown.bind(this);
          this.lastFocusedElementBeforeMobileFilters = null;
          this.updateMobileFilterOffset = this.updateMobileFilterOffset.bind(this);
          this.scrollLockState = {
            applied: false,
            scrollY: 0,
            previousStyles: {}
          };
          this.latestMobileFilterOffset = 0;

          this.tagExistingProductTiles(this.currentPage);
          const promoTile = this.getPromoTile();
          if (promoTile) {
            promoTile.classList.add(this.paginationHiddenClass);
            this.applyTileDisplayState(promoTile);
          }
          this.init();
        }

        init() {
          this.setupFilterListeners();
          this.setupAccordions();
          this.setupBannerListener();
          this.setupMobileFilters();
          this.prefetchAdditionalPages();
          this.applyInitialFiltersFromURL();
          this.updateMobileFilterOffset();
          this.setMobileFiltersAria(!this.isMobileFiltersOpen);
          window.addEventListener('resize', this.handleResize);
          requestAnimationFrame(() => this.equalizeTileHeights());
          this.applyBannerTranslations();
        }

        parseNumber(value, fallback) {
          const parsed = parseInt(value, 10);
          return Number.isNaN(parsed) || parsed <= 0
            ? fallback
            : parsed;
        }

        getInitialPage() {
          try {
            const params = new URLSearchParams(window.location.search);
            const pageParam = parseInt(params.get('page'), 10);
            return Number.isNaN(pageParam) || pageParam < 1
              ? 1
              : pageParam;
          } catch (error) {
            return 1;
          }
        }

        tagExistingProductTiles(page) {
          const tiles = Array.from(this.element.querySelectorAll('.product-grid .product-tile'));
          tiles.forEach((tile, index) => {
            tile.dataset.sourcePage = page.toString();
            tile.dataset.originalOrder = this.calculateOriginalOrder(page, index).toString();
          });
        }

        calculateOriginalOrder(page, index) {
          const normalizedPage = Math.max(page, 1);
          const normalizedIndex = Math.max(index, 0);
          return((normalizedPage - 1) * this.itemsPerPage) + normalizedIndex;
        }

        applyTileDisplayState(tile) {
          if (!tile) {
            return;
          }

          if (tile.classList.contains('hidden') || tile.classList.contains(this.paginationHiddenClass) || tile.classList.contains(this.promoSuppressedClass)) {
            tile.style.setProperty('display', 'none', 'important');
          } else {
            tile.style.removeProperty('display');
          }
        }

        getPromoTile() {
          if (!this.isPromoFeatureEnabled) {
            return null;
          }

          return this.element.querySelector('.promo-tile');
        }

        prefetchAdditionalPages() {
          if (!this.sectionId || this.totalPages<= 1) {
        return;
      }

      const productGrid = this.element.querySelector('.product-grid');
      if (!productGrid || typeof fetch !== 'function') {
        return;
      }

      const pagesToLoad = [];
      for (let page = 1; page <= this.totalPages; page += 1) {
        if (!this.pagesLoaded.has(page)) {
          pagesToLoad.push(page);
        }
      }

      if (pagesToLoad.length === 0) {
        return;
      }

      const baseUrl = new URL(window.location.href);
      const parser = new DOMParser();
      let appendedTiles = false;

      Promise.all(
        pagesToLoad.map(page => {
          const pageUrl = new URL(baseUrl.toString());
          pageUrl.searchParams.set('page', page.toString());
          pageUrl.searchParams.set('section_id', this.sectionId);

          return fetch(pageUrl.toString())
            .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to load collection page ${page}`);
            }
            return response.text();
          }) .then(html => {
              const doc = parser.parseFromString(html, 'text/html');
              const newTiles = Array.from(doc.querySelectorAll('.product-grid .product-tile'));
              if (newTiles.length > 0) {
                this.insertTilesForPage(newTiles, page, productGrid);
                appendedTiles = true;
              }

              if (this.isPromoFeatureEnabled && page === 1) {
                const promoTile = doc.querySelector('.promo-tile');
                if (promoTile && !this.getPromoTile()) {
                  this.insertPromoTile(promoTile, productGrid, page);
                }
              }

              this.pagesLoaded.add(page);
            }).catch(error => {
              console.error('Collection page preload failed', {page, error});
            });
          


        }
      )
    ). finally(() => {
      if (appendedTiles) {
        this.applyFilters({resetPage: false, scroll: false});
      }
    });
  }

  insertTilesForPage(tiles, page, productGrid) {
    const existingTiles = Array.from(productGrid.querySelectorAll('.product-tile'));
    const reference = existingTiles.find(tile => {
      const tilePage = this.parseNumber(tile.dataset.sourcePage, this.currentPage);
      return tilePage > page;
    }) || null;

    tiles.forEach((tile, index) => {
      tile.dataset.sourcePage = page.toString();
      tile.dataset.originalOrder = this.calculateOriginalOrder(page, index).toString();
      tile.classList.add('prefetched', 'hidden', this.paginationHiddenClass);
      this.applyTileDisplayState(tile);
      if (reference) {
        productGrid.insertBefore(tile, reference);
      } else {
        productGrid.appendChild(tile);
      }
    });
  }

  insertPromoTile(promoTile, productGrid, page) {
    if (!this.isPromoFeatureEnabled) {
      return;
    }

    promoTile.dataset.sourcePage = page.toString();
    promoTile.classList.add(this.paginationHiddenClass);
    this.applyTileDisplayState(promoTile);

    const pageTiles = Array.from(this.element.querySelectorAll(`.product-grid .product-tile[data-source-page="${page}"]`));
    const promoInsertIndex = 8;
    const reference = pageTiles[promoInsertIndex] || null;

    if (reference) {
      productGrid.insertBefore(promoTile, reference);
    } else {
      productGrid.appendChild(promoTile);
    }
  }

  setupBannerListener() {
    document.addEventListener('banner-filter-change', (event) => {
      const filter = event.detail.filter;
      const pill = this.element.querySelector(`.product-line-filter[data-filter="${filter}"]`);
      if (pill) {
        this.handleProductLineFilter(pill, filter);
      }
    });
  }

  setupMobileFilters() {
    this.mobileFilterTrigger = this.element.querySelector('[data-floating-filter-trigger]');
    this.mobileFilterPanel = this.element.querySelector('[data-mobile-filter-panel]');
    this.mobileFilterBackdrop = this.element.querySelector('[data-mobile-filter-backdrop]');
    this.mobileFilterClose = this.element.querySelector('[data-mobile-filter-close]');
    this.mobileFilterApply = this.element.querySelector('[data-mobile-filter-apply]');

    if (this.mobileFilterTrigger) {
      this.mobileFilterTrigger.setAttribute('aria-expanded', 'false');
      this.mobileFilterTrigger.addEventListener('click', () => this.openMobileFilters());
    }

    if (this.mobileFilterClose) {
      this.mobileFilterClose.addEventListener('click', () => this.closeMobileFilters());
    }

    if (this.mobileFilterBackdrop) {
      this.mobileFilterBackdrop.addEventListener('click', () => this.closeMobileFilters());
    }

    if (this.mobileFilterApply) {
      this.mobileFilterApply.addEventListener('click', () => {
        // Pill taps in the drawer only stage state changes — commit them
        // here. If the new filter state breaks out of the current
        // collection's implicit scope, redirect to a broader collection
        // (the page navigation handles closing the drawer); otherwise
        // apply in place and close the drawer.
        const redirected = this.commitFilterStateOrRedirect();
        if (redirected) {
          return;
        }
        try {
          this.applyFilters({scroll: false, resetPage: true});
        } catch (e) {
          // Don't let a single render error block the drawer from closing,
          // but surface the failure so it doesn't fail silently.
          console.error('[main-collection] applyFilters failed on POKAŻ PRODUKTY:', e);
        }
        this.closeMobileFilters();
      });
    }
  }

  openMobileFilters() {
    if (!this.mobileFilterPanel) {
      return;
    }

    if (window.innerWidth > 1200) {
      return;
    }

    if (this.isMobileFiltersOpen) {
      return;
    }

    this.isMobileFiltersOpen = true;
    this.updateMobileFilterOffset();
    this.lastFocusedElementBeforeMobileFilters = document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;
    this.lockBodyScroll();
    this.element.classList.add('mobile-filters-open');
    this.setMobileFiltersAria(false);

    if (this.mobileFilterTrigger) {
      this.mobileFilterTrigger.setAttribute('aria-expanded', 'true');
    }

    document.addEventListener('keydown', this.handleMobileFilterKeydown);

    if (this.mobileFilterClose) {
      this.mobileFilterClose.focus();
    }
  }

  closeMobileFilters(options = {}) {
    const {
      restoreFocus = true,
      restoreScroll = true
    } = options;

    if (!this.isMobileFiltersOpen) {
      this.unlockBodyScroll({restoreScroll});
      this.setMobileFiltersAria(true);
      return;
    }

    this.isMobileFiltersOpen = false;
    this.element.classList.remove('mobile-filters-open');
    this.setMobileFiltersAria(true);
    this.unlockBodyScroll({restoreScroll});

    if (this.mobileFilterTrigger) {
      this.mobileFilterTrigger.setAttribute('aria-expanded', 'false');
    }

    document.removeEventListener('keydown', this.handleMobileFilterKeydown);

    if (restoreFocus) {
      const focusTarget = this.lastFocusedElementBeforeMobileFilters || this.mobileFilterTrigger;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    }

    this.lastFocusedElementBeforeMobileFilters = null;
  }

  setMobileFiltersAria(hidden) {
    if (!this.mobileFilterPanel) {
      return;
    }

    this.updateMobileFilterOffset();

    if (window.innerWidth > 1200) {
      this.mobileFilterPanel.setAttribute('aria-hidden', 'false');
      if (this.mobileFilterBackdrop) {
        this.mobileFilterBackdrop.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    this.mobileFilterPanel.setAttribute(
      'aria-hidden',
      hidden
        ? 'true'
        : 'false'
    );
    if (this.mobileFilterBackdrop) {
      this.mobileFilterBackdrop.setAttribute(
        'aria-hidden',
        hidden
          ? 'true'
          : 'false'
      );
    }
  }

  handleMobileFilterKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeMobileFilters();
    }
  }

  lockBodyScroll() {
    if (this.scrollLockState.applied) {
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;

    this.scrollLockState = {
      applied: true,
      scrollY,
      previousStyles: {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      }
    };

    document.documentElement.classList.add('mobile-filter-open');
    document.body.classList.add('mobile-filter-open');

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  unlockBodyScroll(options = {}) {
    const {
      restoreScroll = true
    } = options;

    if (!this.scrollLockState.applied) {
      document.documentElement.classList.remove('mobile-filter-open');
      document.body.classList.remove('mobile-filter-open');
      this.scrollLockState = {
        applied: false,
        scrollY: 0,
        previousStyles: {}
      };
      return;
    }

    const {previousStyles, scrollY} = this.scrollLockState;
    document.body.style.position = previousStyles.position || '';
    document.body.style.top = previousStyles.top || '';
    document.body.style.left = previousStyles.left || '';
    document.body.style.right = previousStyles.right || '';
    document.body.style.width = previousStyles.width || '';
    document.body.style.overflow = previousStyles.overflow || '';

    document.documentElement.classList.remove('mobile-filter-open');
    document.body.classList.remove('mobile-filter-open');

    if (restoreScroll) {
      window.scrollTo(0, scrollY);
    }

    this.scrollLockState = {
      applied: false,
      scrollY: 0,
      previousStyles: {}
    };
  }

  updateMobileFilterOffset() {
    const offset = this.getMobileFilterOffset();
    this.latestMobileFilterOffset = offset;
    if (this.element) {
      this.element.style.setProperty('--collection-mobile-filter-offset', `${offset}px`);
    }
    if (this.mobileFilterPanel) {
      this.mobileFilterPanel.style.setProperty('--collection-mobile-filter-offset', `${offset}px`);
    }
    if (this.mobileFilterBackdrop) {
      this.mobileFilterBackdrop.style.setProperty('--collection-mobile-filter-offset', `${offset}px`);
    }
  }

  getMobileFilterOffset() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return 0;
    }

    const candidates = [document.querySelector('[data-navbar-fixed]'), document.querySelector('[data-navbar-core]'), document.querySelector('header')];

    const header = candidates.find(Boolean);
    if (! header) {
      return 0;
    }

    const rect = header.getBoundingClientRect();
    const bottom = Math.round(rect.bottom);
    if (bottom > 0) {
      return bottom;
    }

    return 0;
  }

  setupFilterListeners() {

// Non-anchor pills (meat types, promotions)
    const filterPills = this.element.querySelectorAll('.filter-pill:not(a)');
    filterPills.forEach(pill => {
      pill.addEventListener('click', (event) => {
        event.stopPropagation();
        const filter = event.currentTarget.dataset.filter;
        if (filter) {
          this.handleFilterClick(event.currentTarget, filter);
        }
      });
    });

// Checkbox pills (for dog/cat)
    this.element.querySelectorAll('.checkbox-pill').forEach(pill => {
      pill.addEventListener('click', (event) => {
        event.stopPropagation();
        const checkbox = event.currentTarget.querySelector('.checkbox');
        checkbox.classList.toggle('checked');
        event.currentTarget.classList.toggle('has-checked', checkbox.classList.contains('checked'));
        const filter = event.currentTarget.dataset.filter;
        this.handleCheckboxFilter(filter, checkbox.classList.contains('checked'));
      });
    });

// Product line anchors: prevent navigation and toggle multi-select
    this.element.querySelectorAll('a.product-line-filter').forEach(anchor => {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const target = event.currentTarget;
        const filter = (target.dataset && target.dataset.filter) || this.getProductLineFromHref(target.getAttribute('href'));
        if (filter) {
          this.handleProductLineFilter(target, filter);
        }
      });

// Support Space and Enter keys as activation like a button
      anchor.addEventListener('keydown', (e) => {
        if (e.code === 'Space' || e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          anchor.click();
        }
      });
    });
  }

  setupAccordions() {
    this.element.querySelectorAll('.filter-accordion').forEach(accordion => {
      accordion.addEventListener('click', () => {
        accordion.classList.toggle('open');
      });
    });
  }

  parseFiltersFromURL() {
    const fallback = {
      categories: [],
      forWhom: [],
      meatType: [],
      productLine: []
    };

    if (typeof window === 'undefined' || !window.location) {
      return fallback;
    }

    try {
      const params = new URLSearchParams(window.location.search || '');
      const normalizeValue = (entry) => {
        if (typeof entry !== 'string') {
          return '';
        }

        let normalized = entry.trim().toLowerCase();
        if (typeof normalized.normalize === 'function') {
          try {
            normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          } catch (err) {}
        }

        normalized = normalized
          .replace(/[\s_]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-+|-+$/g, '');

        return normalized;
      };
      const normalizeList = (value) => {
        if (!value) {
          return [];
        }

        return value
          .split(',')
          .map(normalizeValue)
          .filter(entry => entry.length);
      };

      const filters = {
        categories: [],
        forWhom: [],
        meatType: [],
        productLine: []
      };
      const audienceMap = {
        cat: 'for-cat',
        'for-cat': 'for-cat',
        kot: 'for-cat',
        koty: 'for-cat',
        'dla-kota': 'for-cat',
        'dla-kotow': 'for-cat',
        katze: 'for-cat',
        'fur-katze': 'for-cat',
        'fur-katzen': 'for-cat',
        kocie: 'for-cat',
        cats: 'for-cat',
        dog: 'for-dog',
        'for-dog': 'for-dog',
        pies: 'for-dog',
        psy: 'for-dog',
        'dla-psa': 'for-dog',
        'dla-psow': 'for-dog',
        hund: 'for-dog',
        hunde: 'for-dog',
        hundchen: 'for-dog',
        'fur-hund': 'for-dog',
        'fur-hunde': 'for-dog',
        dogs: 'for-dog',
        perro: 'for-dog',
        perros: 'for-dog'
      };
      const categoryMap = {
        all: 'all',
        bestseller: 'bestseller',
        bestsellers: 'bestseller',
        'best-seller': 'bestseller',
        'best-sellers': 'bestseller',
        topseller: 'bestseller',
        topsellers: 'bestseller',
        'top-seller': 'bestseller',
        'top-sellers': 'bestseller',
        bestsellery: 'bestseller',
        new: 'new',
        'new-in': 'new',
        'new-product': 'new',
        'new-products': 'new',
        'new-arrivals': 'new',
        nowosc: 'new',
        nowosci: 'new',
        nowy: 'new',
        neu: 'new',
        neuheit: 'new',
        neuheiten: 'new',
        'neue-produkte': 'new',
        novinka: 'new',
        promotion: 'promotion',
        promotions: 'promotion',
        promo: 'promotion',
        promocja: 'promotion',
        promocje: 'promotion',
        aktion: 'promotion',
        angebot: 'promotion',
        angebote: 'promotion',
        sale: 'promotion',
        znizka: 'promotion',
        rabatt: 'promotion',
        rabatte: 'promotion',
        discount: 'promotion',
        discounts: 'promotion'
      };
      const meatMap = {
        duck: 'duck',
        'z-kaczki': 'duck',
        kaczka: 'duck',
        ente: 'duck',
        enten: 'duck',
        entenbrust: 'duck',
        entenbrustfilet: 'duck',
        'entenherz': 'duck',
        entenherzen: 'duck',
        'ente-mit-haut': 'duck',
        entenfilet: 'duck',
        chicken: 'chicken',
        'z-kurczaka': 'chicken',
        kurczak: 'chicken',
        huhn: 'chicken',
        huhner: 'chicken',
        'huhnerbrust': 'chicken',
        'huhnerherzen': 'chicken',
        hahnchen: 'chicken',
        'hahnchenbrust': 'chicken',
        'hahnchenherzen': 'chicken',
        'hahnchenfilet': 'chicken',
        haehnchen: 'chicken',
        turkey: 'turkey',
        'z-indyka': 'turkey',
        indyk: 'turkey',
        pute: 'turkey',
        puten: 'turkey',
        putenfleisch: 'turkey',
        putenbrust: 'turkey',
        putenherzen: 'turkey',
        truthahn: 'turkey',
        blend: 'blend',
        mieszane: 'blend',
        mix: 'blend',
        miks: 'blend',
        mischung: 'blend',
        gemischt: 'blend',
        'gemischte-proteine': 'blend',
        mixfleisch: 'blend',
        assorti: 'blend',
        assorted: 'blend'
      };
      const shorthandToFull = this.getSupportedProductLines().reduce((acc, full) => {
        const short = full.replace(/^ayla-/, '');
        acc[short] = full;
        acc[full] = full;
        return acc;
      }, {});

      normalizeList(params.get('category') || params.get('categories')).forEach(value => {
        const mapped = categoryMap[value];
        if (mapped && mapped !== 'all' && ! filters.categories.includes(mapped)) {
          filters.categories.push(mapped);
        }
      });

      normalizeList(params.get('for')).forEach(value => {
        const mapped = audienceMap[value];
        if (mapped && ! filters.forWhom.includes(mapped)) {
          filters.forWhom.push(mapped);
        }
      });

      normalizeList(params.get('meat')).forEach(value => {
        const mapped = meatMap[value] || null;
        if (mapped && ! filters.meatType.includes(mapped)) {
          filters.meatType.push(mapped);
        }
      });

      normalizeList(params.get('line')).forEach(value => {
        const mapped = shorthandToFull[value] || value;
        if (this.getSupportedProductLines().includes(mapped) && ! filters.productLine.includes(mapped)) {
          filters.productLine.push(mapped);
        }
      });

      return filters;
    } catch (error) {
      console.warn('Unable to parse collection filters from URL', error);
      return fallback;
    }
  }

  applyInitialFiltersFromURL() {
    const categoryFilters = [...this.initialFilters.categories];
    const forWhomFilters = [...this.initialFilters.forWhom];
    const meatFilters = [...this.initialFilters.meatType];
    const productLineFilters = [...this.initialFilters.productLine];
    const hasExplicitFilters = categoryFilters.length > 0 || forWhomFilters.length > 0 || meatFilters.length > 0 || productLineFilters.length > 0;

    // Only apply defaults if:
    // 1. There are no explicit filters from URL, AND
    // 2. User hasn't interacted with filters yet
    // This prevents defaults from interfering with user selections
    if (!hasExplicitFilters && !this.userHasInteracted) {
      if (forWhomFilters.length === 0) {
        const defaultAudience = this.getDefaultAudienceFromCollection();
        if (defaultAudience && ! forWhomFilters.includes(defaultAudience)) {
          forWhomFilters.push(defaultAudience);
        }
      }

      if (productLineFilters.length === 0) {
        const defaults = this.getDefaultProductLinesFromCollection();
        defaults.forEach(line => {
          if (! productLineFilters.includes(line)) 
            productLineFilters.push(line);
        });
      }

      if (categoryFilters.length === 0) {
        const defaultCategories = this.getDefaultCategoriesFromCollection();
        defaultCategories.forEach(category => {
          if (! categoryFilters.includes(category)) {
            categoryFilters.push(category);
          }
        });
      }

      if (meatFilters.length === 0) {
        const defaultMeat = this.getDefaultMeatFromCollection();
        if (defaultMeat && ! meatFilters.includes(defaultMeat)) {
          meatFilters.push(defaultMeat);
        }
      }
    }

    const hasFilters = categoryFilters.length > 0 || forWhomFilters.length > 0 || meatFilters.length > 0 || productLineFilters.length > 0;

    this.filters.categories = categoryFilters;
    this.filters.forWhom = forWhomFilters;
    this.filters.meatType = meatFilters;
    this.filters.productLine = productLineFilters;
    this.syncFilterUIFromState();
    this.hasInitialFilters = hasExplicitFilters;

    if (hasFilters) {
      const options = {
        scroll: false
      };
      if (! hasExplicitFilters) {
        options.resetPage = false;
      }
      this.applyFilters(options);
    } else {
      this.applyFilters({resetPage: false, scroll: false});
    }
  }

  getDefaultAudienceFromCollection() {
    if (!this.collectionHandle) {
      return null;
    }

    const normalizedHandle = this.collectionHandle.trim().toLowerCase();
    const audienceMap = {
      cat: 'for-cat',
      'for-cat': 'for-cat',
      kot: 'for-cat',
      koty: 'for-cat',
      'dla-kota': 'for-cat',
      'dla-kotow': 'for-cat',
      katze: 'for-cat',
      'fur-katze': 'for-cat',
      'fur-katzen': 'for-cat',
      kocie: 'for-cat',
      cats: 'for-cat',
      dog: 'for-dog',
      'for-dog': 'for-dog',
      pies: 'for-dog',
      psy: 'for-dog',
      'dla-psa': 'for-dog',
      'dla-psow': 'for-dog',
      hund: 'for-dog',
      hunde: 'for-dog',
      hundchen: 'for-dog',
      'fur-hund': 'for-dog',
      'fur-hunde': 'for-dog',
      dogs: 'for-dog',
      perro: 'for-dog',
      perros: 'for-dog'
    };

    if (audienceMap[normalizedHandle]) {
      return audienceMap[normalizedHandle];
    }

    // Compound handles like "liofilizowane-przysmaki-dla-kota" or
    // "liofilizowany-kurczak-dla-psa" — match the audience suffix.
    if (/(^|-)(dla-kota|dla-kotow)($|-)/.test(normalizedHandle)) return 'for-cat';
    if (/(^|-)(dla-psa|dla-psow)($|-)/.test(normalizedHandle)) return 'for-dog';
    if (/(^|-)(fur-katze|fur-katzen)($|-)/.test(normalizedHandle)) return 'for-cat';
    if (/(^|-)(fur-hund|fur-hunde)($|-)/.test(normalizedHandle)) return 'for-dog';

    return null;
  }

  getSupportedProductLines() {
    return ['ayla-delight', 'ayla-help', 'ayla-rescue'];
  }

  getDefaultProductLinesFromCollection() {
    const line = this.getCollectionImplicitProductLine();
    if (!line) return [];

    // Delight sub-collections (audience/meat variants like
    // gefriergetrocknetes-huhn-fur-katzen) skip line auto-selection —
    // the audience and meat pills already convey that context, so an
    // extra "AYLA Delight" pill is noise. The top Delight collection
    // itself DOES auto-select (matches Help/Rescue behaviour).
    if (line === 'ayla-delight') {
      const handle = (this.collectionHandle || '').trim().toLowerCase();
      const delight = this.collectionLocaleMap.lines.find(l => l.id === 'ayla-delight');
      const topHandle = delight ? delight.topHandle : '';
      return handle === topHandle ? [line] : [];
    }
    return [line];
  }

  getDefaultMeatFromCollection() {
    const handle = (this.collectionHandle || '').trim().toLowerCase();
    if (handle.includes('kurczak') || handle.includes('chicken') || handle.includes('huhn')) return 'chicken';
    if (handle.includes('indyk') || handle.includes('turkey') || handle.includes('pute')) return 'turkey';
    if (handle.includes('kaczk') || handle.includes('duck') || handle.includes('ente')) return 'duck';
    if (handle.includes('mieszan') || handle.includes('blend') || handle.includes('mix')) return 'blend';
    return null;
  }

  getDefaultCategoriesFromCollection() {
    const handle = (this.collectionHandle || '').trim().toLowerCase();
    const mapping = {
      bestseller: ['bestseller'],
      bestsellers: ['bestseller'],
      'best-seller': ['bestseller'],
      'best-sellers': ['bestseller'],
      topseller: ['bestseller'],
      topsellers: ['bestseller'],
      'top-seller': ['bestseller'],
      'top-sellers': ['bestseller'],
      bestsellery: ['bestseller'],
      new: ['new'],
      'new-in': ['new'],
      'new-product': ['new'],
      'new-products': ['new'],
      'new-arrivals': ['new'],
      nowosc: ['new'],
      nowosci: ['new'],
      nowy: ['new'],
      neu: ['new'],
      neuheit: ['new'],
      neuheiten: ['new'],
      'neue-produkte': ['new'],
      novinka: ['new'],
      promotion: ['promotion'],
      promotions: ['promotion'],
      promo: ['promotion'],
      promocja: ['promotion'],
      promocje: ['promotion'],
      aktion: ['promotion'],
      angebot: ['promotion'],
      angebote: ['promotion'],
      sale: ['promotion'],
      znizka: ['promotion'],
      rabatt: ['promotion'],
      rabatte: ['promotion'],
      discount: ['promotion'],
      discounts: ['promotion']
    };
    return mapping[handle]
      ? [... mapping[handle]]
      : [];
  }

  getProductLineFromHref(href) {
    if (!href) {
      return null;
    }

    try {
      const match = href.toLowerCase().match(/ayla-(delight|help|rescue)/);
      if (match) {
        return `ayla-${match[1]}`;
      }
    } catch (err) {}

    return null;
  }

  handleProductLineFilter(pill, filter) {
    if (!filter || !this.getSupportedProductLines().includes(filter)) return;

    this.userHasInteracted = true;
    this.toggleArrayFilter('productLine', filter);

    if (pill && pill.classList) {
      const isActive = this.filters.productLine.includes(filter);
      pill.classList.toggle('selected', isActive);
      pill.setAttribute('aria-pressed', String(isActive));
    }

    // While the mobile filter drawer is open, defer the decision until
    // the user taps "POKAŻ PRODUKTY".
    if (this.isMobileFiltersOpen) {
      return;
    }

    // Desktop / no-drawer: redirect when the line selection no longer
    // fits the current collection's implicit line, else apply in place.
    const redirected = this.commitFilterStateOrRedirect();
    if (redirected) {
      return;
    }
    this.applyFilters();
  }

  handleFilterClick(pill, filter) {
    if (!filter) {
      return;
    }

    // Mark that user has interacted with filters
    this.userHasInteracted = true;

    if (filter === 'all') {
      if (this.filters.categories.length > 0) {
        this.filters.categories = [];
      }
      this.syncFilterUIFromState();
      this.applyFilters();
      return;
    }

    if (this.categoryFilters.includes(filter)) {
      this.toggleArrayFilter('categories', filter);
      this.syncFilterUIFromState();
      this.applyFilters();
      return;
    }

    if (this.meatFilters.includes(filter)) {
      this.toggleArrayFilter('meatType', filter);
      const isActive = this.filters.meatType.includes(filter);
      if (pill && pill.classList) {
        pill.classList.toggle('selected', isActive);
      }

      // While the mobile filter drawer is open, just stage the change.
      // The "POKAŻ PRODUKTY" button commits the full set of changes
      // (and decides whether to apply in place or redirect).
      if (this.isMobileFiltersOpen) {
        return;
      }

      // Desktop / no-drawer path: redirect if the new selection no
      // longer fits the collection's implicit meat scope, else apply
      // in place.
      const collectionMeat = this.getDefaultMeatFromCollection();
      if (collectionMeat) {
        const matchesCollection = this.filters.meatType.length === 1
          && this.filters.meatType[0] === collectionMeat;
        if (!matchesCollection) {
          const broaderUrl = this.buildBroadenedUrl(this.getMeatAgnosticCollectionUrl());
          window.location.href = broaderUrl;
          return;
        }
      }

      this.applyFilters();
    }
  }

  parseCollectionLocaleMap(raw) {
    const fallback = { lines: [], audienceSuffixes: {} };
    if (!raw) return fallback;
    try {
      const parsed = JSON.parse(raw);
      return {
        lines: Array.isArray(parsed.lines) ? parsed.lines : [],
        audienceSuffixes: parsed.audienceSuffixes || {}
      };
    } catch (e) {
      return fallback;
    }
  }

  // Find the product-line config (from the locale map) whose handle rules
  // match the given collection handle. Returns null if none match.
  getLineConfigForHandle(handle) {
    const h = (handle || '').trim().toLowerCase();
    if (!h) return null;
    for (const line of this.collectionLocaleMap.lines) {
      if (line.topHandle === h) return line;
      if (Array.isArray(line.handlePrefixes) && line.handlePrefixes.some(p => h.startsWith(p))) return line;
      if (Array.isArray(line.handleContains) && line.handleContains.some(c => h.includes(c))) return line;
    }
    return null;
  }

  getMeatAgnosticCollectionUrl() {
    const handle = (this.collectionHandle || '').trim().toLowerCase();
    const allProductsUrl = (this.element && this.element.dataset && this.element.dataset.allProductsUrl) || '/collections/all';

    const line = this.getLineConfigForHandle(handle);
    if (!line) return allProductsUrl;

    // If the line's meat sub-collections are audience-specific (e.g.
    // liofilizowany-kurczak-dla-kota), preserve the audience suffix when
    // broadening the meat scope. Otherwise just land on the line's top.
    const isMeatAware = Array.isArray(line.meatAwarePrefixes)
      && line.meatAwarePrefixes.some(p => handle.startsWith(p));
    if (isMeatAware) {
      const audience = this.getDefaultAudienceFromCollection();
      const audienceSuffix = (audience && this.collectionLocaleMap.audienceSuffixes[audience]) || '';
      return `/collections/${line.topHandle}${audienceSuffix}`;
    }
    return `/collections/${line.topHandle}`;
  }

  handleCheckboxFilter(filter, isChecked) {
    if (!this.audienceFilters.includes(filter)) {
      return;
    }

    // Mark that user has interacted with filters
    this.userHasInteracted = true;

    const key = filter === 'for-dog'
      ? 'for-dog'
      : 'for-cat';

    // Update internal state first so we can compare it against the
    // collection's implicit audience.
    if (isChecked) {
      if (!this.filters.forWhom.includes(key)) {
        this.filters.forWhom.push(key);
      }
    } else {
      this.filters.forWhom = this.filters.forWhom.filter(entry => entry !== key);
    }

    // While the mobile filter drawer is open, just stage the change.
    // The "POKAŻ PRODUKTY" button commits the full set of changes
    // (and decides whether to apply in place or redirect).
    if (this.isMobileFiltersOpen) {
      return;
    }

    // Desktop / no-drawer path: if the current collection is constrained
    // to one audience and the user's selection no longer matches it
    // (cleared, swapped, or expanded), navigate to a broader collection
    // and preserve the new filter state via URL params.
    const collectionAudience = this.getDefaultAudienceFromCollection();
    if (collectionAudience) {
      const matchesCollection = this.filters.forWhom.length === 1
        && this.filters.forWhom[0] === collectionAudience;
      if (!matchesCollection) {
        const broaderUrl = this.buildBroadenedUrl(this.getAudienceAgnosticCollectionUrl());
        window.location.href = broaderUrl;
        return;
      }
    }

    this.applyFilters();
  }

  // Returns the product line the current collection implicitly belongs
  // to (regardless of whether we auto-check the matching pill on init).
  getCollectionImplicitProductLine() {
    const handle = (this.collectionHandle || '').trim().toLowerCase();
    const supported = this.getSupportedProductLines();
    if (supported.includes(handle)) return handle;
    const line = this.getLineConfigForHandle(handle);
    return line ? line.id : null;
  }

  // Map a product-line filter value back to its top-level landing
  // collection. Used when the user picks a line that doesn't match the
  // current collection so we can redirect them to the right page.
  getCollectionUrlForProductLine(line) {
    const entry = this.collectionLocaleMap.lines.find(l => l.id === line);
    return entry ? `/collections/${entry.topHandle}` : null;
  }

  // Decide whether the current filter state requires a redirect to a
  // broader (or different) collection or can be applied in place. Used
  // by the mobile drawer's "POKAŻ PRODUKTY" button so all staged pill
  // changes commit together, and by the desktop pill handlers.
  commitFilterStateOrRedirect() {
    const allProductsUrl = (this.element && this.element.dataset && this.element.dataset.allProductsUrl) || '/collections/all';

    // Line check first — line determines which top-level collection is
    // the right destination, the other axes operate within that.
    // An empty line filter on a line-constrained collection means the
    // user wants out of that line entirely, so it counts as a mismatch
    // (matches the behaviour of audience / meat).
    const collectionLine = this.getCollectionImplicitProductLine();
    const lineMatches = collectionLine
      ? (this.filters.productLine.length === 1 && this.filters.productLine[0] === collectionLine)
      : true;

    if (collectionLine && !lineMatches) {
      let baseUrl;
      if (this.filters.productLine.length === 1) {
        baseUrl = this.getCollectionUrlForProductLine(this.filters.productLine[0]) || allProductsUrl;
      } else {
        // Multiple lines selected at once — no single line collection
        // satisfies the request, so widen all the way out.
        baseUrl = allProductsUrl;
      }
      window.location.href = this.buildBroadenedUrl(baseUrl);
      return true;
    }

    const collectionAudience = this.getDefaultAudienceFromCollection();
    const audienceMatches = collectionAudience
      ? (this.filters.forWhom.length === 1 && this.filters.forWhom[0] === collectionAudience)
      : true;
    if (collectionAudience && !audienceMatches) {
      window.location.href = this.buildBroadenedUrl(this.getAudienceAgnosticCollectionUrl());
      return true;
    }

    const collectionMeat = this.getDefaultMeatFromCollection();
    const meatMatches = collectionMeat
      ? (this.filters.meatType.length === 1 && this.filters.meatType[0] === collectionMeat)
      : true;
    if (collectionMeat && !meatMatches) {
      window.location.href = this.buildBroadenedUrl(this.getMeatAgnosticCollectionUrl());
      return true;
    }
    return false;
  }

  buildBroadenedUrl(baseUrl) {
    const fallbackOrigin = (typeof window !== 'undefined' && window.location)
      ? window.location.origin
      : 'http://localhost';

    // Preserve the current market's root path (e.g. "/de-de") so the
    // broaden-on-mismatch redirect keeps the user on the same locale.
    // Primary markets have an empty root_url, so this is a no-op for PL.
    let prefixed = baseUrl;
    const marketRoot = (this.element && this.element.dataset && this.element.dataset.marketRootUrl) || '';
    if (marketRoot && typeof baseUrl === 'string' && baseUrl.startsWith('/') && !baseUrl.startsWith('//') && !baseUrl.startsWith(marketRoot + '/') && baseUrl !== marketRoot) {
      prefixed = marketRoot + baseUrl;
    }

    let url;
    try {
      url = new URL(prefixed, fallbackOrigin);
    } catch (e) {
      return prefixed;
    }

    if (this.filters.forWhom.length > 0) {
      const v = this.filters.forWhom
        .map(f => (f === 'for-dog' ? 'dog' : 'cat'))
        .sort()
        .join(',');
      url.searchParams.set('for', v);
    } else {
      url.searchParams.delete('for');
    }

    if (this.filters.meatType.length > 0) {
      const v = [...this.filters.meatType].sort().join(',');
      url.searchParams.set('meat', v);
    } else {
      url.searchParams.delete('meat');
    }

    if (this.filters.productLine.length > 0) {
      const v = [...this.filters.productLine].sort().join(',');
      url.searchParams.set('line', v);
    }

    if (this.filters.categories.length > 0) {
      const v = [...this.filters.categories].sort().join(',');
      url.searchParams.set('category', v);
    }

    return url.pathname + (url.search || '');
  }

  getAudienceAgnosticCollectionUrl() {
    const handle = (this.collectionHandle || '').trim().toLowerCase();
    const allProductsUrl = (this.element && this.element.dataset && this.element.dataset.allProductsUrl) || '/collections/all';

    // Preserve any implicit meat constraint (kurczak/indyk/kaczka) as a URL
    // param, otherwise broadening the audience also silently drops the
    // meat context — surprising to the user.
    const collectionMeat = this.getDefaultMeatFromCollection();
    const querySuffix = collectionMeat ? `?meat=${collectionMeat}` : '';

    // Map any sub-collection of a known product line back to that line's
    // top-level collection (which contains both species).
    const line = this.getLineConfigForHandle(handle);
    if (line) return `/collections/${line.topHandle}${querySuffix}`;
    return allProductsUrl;
  }

  toggleArrayFilter(filterType, value) {
    if (this.filters[filterType].includes(value)) {
      this.filters[filterType] = this.filters[filterType].filter(entry => entry !== value);
    } else {
      this.filters[filterType].push(value);
    }
  }

  syncFilterUIFromState() {

// Category pills
    const categoryPills = this.element.querySelectorAll('.filter-pill.category-pill');
    const hasCategoryFilters = this.filters.categories.length > 0;
    categoryPills.forEach(pill => {
      const pillFilter = (pill.dataset.filter || '').toLowerCase();
      if (pillFilter === 'all') {
        const isSelected = ! hasCategoryFilters;
        pill.classList.toggle('selected', isSelected);
        pill.setAttribute('aria-pressed', String(isSelected));
      } else if (this.categoryFilters.includes(pillFilter)) {
        const isActive = this.filters.categories.includes(pillFilter);
        pill.classList.toggle('selected', isActive);
        pill.setAttribute('aria-pressed', String(isActive));
      }
    });

// Audience (for whom)
    this.element.querySelectorAll('.checkbox-pill').forEach(pill => {
      const filter = pill.dataset.filter;
      const isActive = this.filters.forWhom.includes(filter);
      pill.classList.toggle('has-checked', isActive);
      const checkbox = pill.querySelector('.checkbox');
      if (checkbox) {
        checkbox.classList.toggle('checked', isActive);
      }
    });


// Product lines
    this.getSupportedProductLines().forEach(line => {
      const pill = this.element.querySelector(`a.product-line-filter[data-filter="${line}"]`);
      if (pill) {
        const isActive = this.filters.productLine.includes(line);
        pill.classList.toggle('selected', isActive);
        pill.setAttribute('aria-pressed', String(isActive));
      }
    });

// Meat types
    this.meatFilters.forEach(filter => {
      const pill = this.element.querySelector(`.filter-pill[data-filter="${filter}"]`);
      if (pill) {
        const isActive = this.filters.meatType.includes(filter);
        pill.classList.toggle('selected', isActive);
      }
    });
  }

  applyFilters(options = {}) {
    const {
      resetPage = true,
      scroll = true
    } = options;
    const productTiles = this.element.querySelectorAll('.product-tile');
    const categoryDatasetMap = {
      bestseller: 'bestseller',
      new: 'new',
      promotion: 'promotion'
    };
    let visibleCount = 0;

    if (resetPage || !this.currentPage) {
      this.currentPage = 1;
    }

    productTiles.forEach(tile => {
      let shouldShow = true;
      const dataset = tile.dataset;

      if (shouldShow && this.filters.categories.length > 0) {
        // Apply category filtering (bestseller, new, promotion)
        const matchesCategory = this.filters.categories.some(category => {
          const key = categoryDatasetMap[category];
          if (!key) {
            return false;
          }

          return dataset[key] === 'true';
        });
        if (!matchesCategory) {
          shouldShow = false;
        }
      }

      if (shouldShow && this.filters.forWhom.length > 0) {
        const hasMatch = this.filters.forWhom.some(filter => dataset[filter.replace('-', '')] === 'true');
        if (!hasMatch) {
          shouldShow = false;
        }
      }

      if (shouldShow && this.filters.productLine.length > 0) {
        const productLine = dataset.line || '';
        const hasMatch = this.filters.productLine.includes(productLine);
        if (!hasMatch) {
          shouldShow = false;
        }
      }

      if (shouldShow && this.filters.meatType.length > 0) {
        const meatValues = (dataset.meat || '').split(',').map(value => value.trim()).filter(Boolean);
        const hasMatch = meatValues.some(value => this.filters.meatType.includes(value));
        if (!hasMatch) {
          shouldShow = false;
        }
      }

      tile.classList.toggle('hidden', !shouldShow);
      if (shouldShow) {
        visibleCount += 1;
      }
      this.applyTileDisplayState(tile);
    });

    this.sortProductTiles();

    const promoTile = this.getPromoTile();
    this.isPromoVisibleOnFirstPage = false;
    if (promoTile) {
      const shouldShowPromo = visibleCount >= 8;
      this.isPromoVisibleOnFirstPage = shouldShowPromo;
      promoTile.classList.toggle(this.promoSuppressedClass, !shouldShowPromo);
      this.applyTileDisplayState(promoTile);
    }

    this.syncFilterUIFromState();
    this.updateSourcePagesAfterSort();
    this.updatePagination(visibleCount, {scroll});
    this.updateURLFromFilters();
    
    // Dispatch collection-filter-change event for banner switching
    const filterEvent = new CustomEvent('collection-filter-change', {
      detail: {
        filter: this.filters.productLine.length > 0 ? this.filters.productLine[0] : null,
        meatTypes: [...this.filters.meatType],
        bannerType: this.filters.productLine.length > 0 ? this.filters.productLine[0] : null
      }
    });
    document.dispatchEvent(filterEvent);
    
    requestAnimationFrame(() => this.equalizeTileHeights());
  }

        applyBannerTranslations() {
          const banner = document.querySelector('.products-banner');
          if (!banner) {
            return;
          }

          const data = banner.dataset || {};
          const mappings = [
            {selector: '.tile-delight .tile-eyebrow', value: data.bannerEyebrowDelight},
            {selector: '.tile-delight .tile-headline', value: data.bannerHeadlineDelight},
            {selector: '.tile-delight .tile-hover-button span', value: data.bannerButtonDelight},
            {selector: '.tile-help .tile-eyebrow', value: data.bannerEyebrowHelp},
            {selector: '.tile-help .tile-headline', value: data.bannerHeadlineHelp},
            {selector: '.tile-help .tile-hover-button span', value: data.bannerButtonHelp},
            {selector: '.tile-rescue .tile-eyebrow', value: data.bannerEyebrowRescue},
            {selector: '.tile-rescue .tile-headline', value: data.bannerHeadlineRescue},
            {selector: '.tile-rescue .tile-hover-button span', value: data.bannerButtonRescue}
          ];

          mappings.forEach(({selector, value}) => {
            if (!value) {
              return;
            }
            const node = banner.querySelector(selector);
            if (node && node.textContent?.trim() !== value) {
              node.textContent = value;
            }
          });
        }

  sortProductTiles() {
    const productGrid = this.element.querySelector('.product-grid');
    if (! productGrid) {
      return;
    }

    const tiles = Array.from(productGrid.querySelectorAll('.product-tile'));
    if (! tiles.length) {
      return;
    }

    const promoTile = this.getPromoTile();
    let promoPlaceholder = null;

    if (promoTile && promoTile.parentNode === productGrid) {
      promoPlaceholder = document.createComment('promo-placeholder');
      productGrid.insertBefore(promoPlaceholder, promoTile);
      productGrid.removeChild(promoTile);
    }

    tiles.sort((a, b) => {
      // Sold-out / force-unavailable products always render after available ones,
      // regardless of the merchant's selected sort order.
      const availableA = a.dataset.available !== 'false';
      const availableB = b.dataset.available !== 'false';
      if (availableA !== availableB) {
        return availableA ? -1 : 1;
      }

      const priorityA = this.parseNumber(a.dataset.linePriority, 99);
      const priorityB = this.parseNumber(b.dataset.linePriority, 99);
      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      const featureA = this.parseNumber(a.dataset.featurePriority, 99);
      const featureB = this.parseNumber(b.dataset.featurePriority, 99);
      if (featureA !== featureB) {
        return featureA - featureB;
      }

      const orderA = this.parseNumber(a.dataset.originalOrder, 0);
      const orderB = this.parseNumber(b.dataset.originalOrder, 0);
      return orderA - orderB;
    });

    tiles.forEach(tile => {
      productGrid.appendChild(tile);
    });

    if (promoTile) {
      if (promoPlaceholder && promoPlaceholder.parentNode === productGrid) {
        productGrid.insertBefore(promoTile, promoPlaceholder);
        productGrid.removeChild(promoPlaceholder);
      } else {
        productGrid.appendChild(promoTile);
      }
    }
  }

  updateSourcePagesAfterSort() {
    const productGrid = this.element.querySelector('.product-grid');
    if (! productGrid) {
      return;
    }

    const visibleTiles = Array.from(productGrid.querySelectorAll('.product-tile:not(.hidden)'));
    const hiddenTiles = Array.from(productGrid.querySelectorAll('.product-tile.hidden'));
    const firstPageCapacity = this.getPageCapacity(1);

    visibleTiles.forEach((tile, index) => {
      let page = 1;
      if (index >= firstPageCapacity) {
        const remaining = index - firstPageCapacity;
        page = 2 + Math.floor(remaining / this.itemsPerPage);
      }
      tile.dataset.sourcePage = page.toString();
    });

    hiddenTiles.forEach(tile => {
      tile.dataset.sourcePage = '0';
    });
  }

  calculateTotalPages(visibleCount) {
    if (visibleCount <= 0) {
      return 1;
    }

    const firstPageCapacity = this.getPageCapacity(1);
    if (visibleCount <= firstPageCapacity) {
      return 1;
    }

    const remaining = visibleCount - firstPageCapacity;
    return 1 + Math.ceil(remaining / this.itemsPerPage);
  }

  updatePagination(visibleCount, options = {}) {
    const {
      scroll = true
    } = options;
    const paginationContainer = this.element.querySelector('.pagination-container');
    const collectionPagination = this.element.querySelector('.collection-pagination');

    if (! paginationContainer || ! collectionPagination) {
      return;
    }

    const totalPages = this.calculateTotalPages(visibleCount);
    this.currentPage = Math.min(Math.max(this.currentPage || 1, 1), totalPages);

    if (totalPages <= 1) {
      collectionPagination.style.display = 'none';
      paginationContainer.innerHTML = '';
      this.paginateProducts({scroll});
      return;
    }

    collectionPagination.style.display = 'flex';

    let paginationHTML = '';
    const pagLabels = document.querySelector('.collection-products')?.dataset || {};
    const pagLabel = (value, fallback) => String(value || fallback).replace(/"/g, '&quot;');
    const prevLabel = pagLabel(pagLabels.labelPreviousPage, 'Previous page');
    const nextLabel = pagLabel(pagLabels.labelNextPage, 'Next page');

    if (this.currentPage > 1) {
      paginationHTML += `
          <button class="page-prev" aria-label="${prevLabel}" data-page="${
        this.currentPage - 1
      }">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M9.57153 2.5L3.94653 7.5625L9.57153 12.625" stroke="#F9F9F4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>`;
    }

    const pagesToShow = new Set([1, totalPages]);
    for (let index = this.currentPage - 2; index <= this.currentPage + 2; index += 1) {
      if (index > 0 && index <= totalPages) {
        pagesToShow.add(index);
      }
    }

    const sortedPages = Array.from(pagesToShow).sort((a, b) => a - b);
    let lastPage = 0;

    sortedPages.forEach(page => {
      if (page - lastPage > 1) {
        paginationHTML += '<div class="page-ellipsis">...</div>';
      }

      if (page === this.currentPage) {
        paginationHTML += `<div class="page-number active">${page}</div>`;
      } else {
        paginationHTML += `<button class="page-number" data-page="${page}">${page}</button>`;
      } lastPage = page;
    });

    if (this.currentPage<totalPages) {
        paginationHTML += `
          <button class="page-next" aria-label="${nextLabel}" data-page="${this.currentPage + 1}">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M4.42847 2.5L10.0535 7.5625L4.42847 12.625" stroke="#F9F9F4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>`;
      }

      paginationContainer.innerHTML = paginationHTML;

      paginationContainer.querySelectorAll('[data-page]').forEach(button => {
      button.addEventListener('click', (event) => {
        const target = parseInt(event.currentTarget.dataset.page, 10);
        if (!Number.isNaN(target)) {
          this.goToPage(target);
        }
      });
    }) 


      this.paginateProducts({scroll});
    

  }

  goToPage(page, options = {}) {
    this.currentPage = page;
    const visibleCount = this.element.querySelectorAll('.product-tile:not(.hidden)').length;
    this.updatePagination(visibleCount, options);
    this.updateURLFromFilters();
  }

  getPageCapacity(page) {
    if (page === 1 && this.isPromoVisibleOnFirstPage) {
      return Math.max(this.itemsPerPage - 1, 1);
    }
    return this.itemsPerPage;
  }

  getStartIndex(page) {
    if (page <= 1) {
      return 0;
    }

    let index = 0;
    for (let current = 1; current < page; current += 1) {
      index += this.getPageCapacity(current);
    }
    return index;
  }

  paginateProducts(options = {}) {
    const {
      scroll = true
    } = options;
    const productTiles = this.element.querySelectorAll('.product-tile');
    const visibleTiles = this.element.querySelectorAll('.product-tile:not(.hidden)');
    const promoTile = this.getPromoTile();
    const startIndex = this.getStartIndex(this.currentPage);
    const pageCapacity = this.getPageCapacity(this.currentPage);
    const endIndex = startIndex + pageCapacity;

    productTiles.forEach(tile => {
      tile.classList.add(this.paginationHiddenClass);
      this.applyTileDisplayState(tile);
    });

    visibleTiles.forEach((tile, index) => {
      if (index >= startIndex && index < endIndex) {
        tile.classList.remove(this.paginationHiddenClass);
      } else {
        tile.classList.add(this.paginationHiddenClass);
      }
      this.applyTileDisplayState(tile);
    });

    if (promoTile) {
      const promoSuppressed = promoTile.classList.contains(this.promoSuppressedClass);
      const shouldShowPromo = this.currentPage === 1 && this.isPromoVisibleOnFirstPage && !promoSuppressed;
      promoTile.classList.toggle(this.paginationHiddenClass, !shouldShowPromo);
      this.applyTileDisplayState(promoTile);
    }

    if (scroll) {
      const container = this.element.querySelector('.collection-container');
      if (container) {
        container.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }

    requestAnimationFrame(() => this.equalizeTileHeights());
  }

  handleResize() {
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
    }

    this.resizeRaf = requestAnimationFrame(() => {
        this.resizeRaf = null;
        const isMobileViewport = window.innerWidth<= 1200;
        if (!isMobileViewport && this.isMobileFiltersOpen) {
          this.closeMobileFilters({restoreFocus: false});
        }
        this.setMobileFiltersAria(isMobileViewport ? !this.isMobileFiltersOpen : false);
        this.equalizeTileHeights();
      });
    }

    equalizeTileHeights() {
      const productGrid = this.element.querySelector('.product-grid');
      if (!productGrid) {
        return;
      }

      const tiles = [];
      const selectors = ['.product-tile'];
      if (this.isPromoFeatureEnabled) {
        selectors.push('.promo-tile');
      }

      selectors.forEach(selector => {
          productGrid.querySelectorAll(selector).forEach(tile => {
            if (tile.classList.contains('hidden')) {
              return;
            }
            if (tile.classList.contains(this.paginationHiddenClass)) {
              return;
            }
            if (tile.classList.contains(this.promoSuppressedClass)) {
              return;
            }
            tiles.push(tile);
          });
        }
      );

      if (!tiles.length) {
        return;
      }

      tiles.forEach(tile => {
        tile.style.removeProperty('height');
      });

      const rows = new Map();
      tiles.forEach(tile => {
        const top = Math.round(tile.offsetTop);
        if (! rows.has(top)) {
          rows.set(top, []);
        }
        rows.get(top).push(tile);
      });

      rows.forEach(group => {
        const maxHeight = Math.max(...group.map(tile => tile.offsetHeight));
        group.forEach(tile => {
          tile.style.height = `${maxHeight}px`;
        });
      });

      this.alignProductTitleSpacing();
    }

    alignProductTitleSpacing() {
      const productGrid = this.element.querySelector('.product-grid');
      if (! productGrid) {
        return;
      }

      const tiles = Array.from(productGrid.querySelectorAll('.product-tile')).filter(tile => {
        if (tile.classList.contains('hidden')) {
          return false;
        }
        if (tile.classList.contains(this.paginationHiddenClass)) {
          return false;
        }
        return true;
      });

      if (! tiles.length) {
        return;
      }

      tiles.forEach(tile => {
        const title = tile.querySelector('.product-name a');
        if (title) {
          title.style.removeProperty('padding-top');
          title.style.removeProperty('min-height');
        }

        const description = tile.querySelector('.product-description');
        if (description) {
          description.style.removeProperty('min-height');
        }
      });

      const rows = new Map();
      tiles.forEach(tile => {
        const top = Math.round(tile.offsetTop);
        if (! rows.has(top)) {
          rows.set(top, []);
        }
        rows.get(top).push(tile);
      });

      rows.forEach(group => {
        const measurements = group.map(tile => {
          const title = tile.querySelector('.product-name a');
          if (! title) {
            return null;
          }
          const height = title.getBoundingClientRect().height;
          return {title, height};
        }).filter(Boolean);

        if (! measurements.length) {
          return;
        }

        const maxHeight = Math.max(... measurements.map(item => item.height));
        const normalizedHeight = Math.ceil(maxHeight);

        measurements.forEach(item => {
          item.title.style.minHeight = `${normalizedHeight}px`;
        });

        const descriptionMeasurements = group.map(tile => {
          const description = tile.querySelector('.product-description');
          if (! description) {
            return null;
          }
          const height = description.getBoundingClientRect().height;
          return {description, height};
        }).filter(Boolean);

        if (descriptionMeasurements.length) {
          const maxDescriptionHeight = Math.max(... descriptionMeasurements.map(item => item.height));
          const normalizedDescriptionHeight = Math.ceil(maxDescriptionHeight);
          descriptionMeasurements.forEach(item => {
            item.description.style.minHeight = `${normalizedDescriptionHeight}px`;
          });
        }
      });

      const desiredGap = this.getDescriptionButtonGap();
      this.applyDescriptionButtonGap(tiles, desiredGap);
    }

    getDescriptionButtonGap() {
      const styles = window.getComputedStyle(this.element);
      const value = styles.getPropertyValue('--product-info-button-gap').trim();
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) {
        return 24;
      }
      return Math.min(parsed, 24);
    }

    applyDescriptionButtonGap(tiles, desiredGap) {
      if (!Array.isArray(tiles) || !tiles.length) {
        return;
      }

      tiles.forEach(tile => {
        const description = tile.querySelector('.product-description');
        const form = tile.querySelector('.product-details form');
        if (! description || ! form) {
          return;
        }

        form.style.marginTop = '0px';

        const descriptionRect = description.getBoundingClientRect();
        const formRect = form.getBoundingClientRect();
        if (! descriptionRect || ! formRect) {
          return;
        }

        const currentGap = formRect.top - descriptionRect.bottom;
        const adjustment = desiredGap - currentGap;
        const normalizedAdjustment = Math.abs(adjustment) < 0.5
          ? 0
          : adjustment;
        form.style.marginTop = `${normalizedAdjustment}px`;
      });
    }

    updateURLFromFilters() {
      if (typeof window === 'undefined' || !window.history || !window.location) {
        return;
      }
      try {
        const url = new URL(window.location.href);
        const params = url.searchParams;

// for=cat,dog
        const audienceOut = this
          .filters
          .forWhom
          .map(v => (
            v === 'for-dog'
              ? 'dog'
              : v === 'for-cat'
                ? 'cat'
                : null
          ))
          .filter(Boolean)
          .sort();
        if (audienceOut.length) {
          params.set('for', audienceOut.join(','));
        } else {
          params.delete('for');
        }

// category=bestseller,new,promotion
        const categoryOut = [...this.filters.categories].sort();
        const defaultCategories = [...this.getDefaultCategoriesFromCollection()].sort();
        const hasSameDefaults = categoryOut.length === defaultCategories.length && categoryOut.every((value, index) => value === defaultCategories[index]);
        if (categoryOut.length && ! hasSameDefaults) {
          params.set('category', categoryOut.join(','));
        } else {
          params.delete('category');
        }

// meat=...
        const meatOut = [...this.filters.meatType].sort();
        if (meatOut.length) {
          params.set('meat', meatOut.join(','));
        } else {
          params.delete('meat');
        }

// line=...
        const lineOut = [...this.filters.productLine].sort();
        const defaults = this.getDefaultProductLinesFromCollection();
        const shouldOmitLine = lineOut.length === 1 && defaults.length === 1 && lineOut[0] === defaults[0];
        if (lineOut.length && ! shouldOmitLine) {
          params.set('line', lineOut.join(','));
        } else {
          params.delete('line');
        }

// page=N (only when > 1)
        if (this.currentPage && this.currentPage > 1) {
          params.set('page', String(this.currentPage));
        } else {
          params.delete('page');
        }

// Commit without navigation
        const next = `${
          url.pathname
        }?${
          params.toString()
        }${
          url.hash
        }`.replace(/\?$/, '');
        const current = `${
          window.location.pathname
        }${
          window.location.search
        }${
          window.location.hash
        }`;
        if (next !== current) {
          window.history.replaceState(null, '', next);
        }
      } catch (err) {
        console.warn('Unable to update URL from filters', err);
      }
    }
  }

  // Sort products by line priority and feature priority
  function sortProductsByPriority() {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    const tiles = Array.from(productGrid.querySelectorAll('.product-tile'));
    if (tiles.length === 0) return;

    // Sort tiles by availability first (sold-out always last), then line priority,
    // then feature priority. Unavailable products must render at the end of the list
    // regardless of the merchant's selected sort order (LUM-1120).
    tiles.sort((a, b) => {
      const availableA = a.dataset.available !== 'false';
      const availableB = b.dataset.available !== 'false';
      if (availableA !== availableB) {
        return availableA ? -1 : 1;
      }

      const linePriorityA = parseInt(a.dataset.linePriority, 10) || 99;
      const linePriorityB = parseInt(b.dataset.linePriority, 10) || 99;

      if (linePriorityA !== linePriorityB) {
        return linePriorityA - linePriorityB;
      }

      const featurePriorityA = parseInt(a.dataset.featurePriority, 10) || 99;
      const featurePriorityB = parseInt(b.dataset.featurePriority, 10) || 99;

      if (featurePriorityA !== featurePriorityB) {
        return featurePriorityA - featurePriorityB;
      }

      // Maintain original order for products with same priorities
      const orderA = parseInt(a.dataset.originalOrder, 10) || 0;
      const orderB = parseInt(b.dataset.originalOrder, 10) || 0;
      return orderA - orderB;
    });

    // Get the promo tile if it exists (we'll re-insert it later)
    const promoTile = productGrid.querySelector('.promo-tile');
    
    // Re-append tiles in sorted order
    tiles.forEach((tile, index) => {
      tile.dataset.originalOrder = index;
      productGrid.appendChild(tile);
    });

    // Re-insert promo tile after 8th product if it exists
    if (promoTile && tiles.length >= 8) {
      const eighthProduct = tiles[7];
      if (eighthProduct && eighthProduct.nextSibling) {
        productGrid.insertBefore(promoTile, eighthProduct.nextSibling);
      } else {
        productGrid.appendChild(promoTile);
      }
    }

    console.log('[Collection] Products sorted by priority');
  }

  function initializeCollection () {
    const collectionElement = document.querySelector('.main-collection');
    if (! collectionElement) return;

    const manager = new CollectionManager(collectionElement);

    // Sort products by priority on initial load
    sortProductsByPriority();

    console.log('Collection initialized with Shopify pagination');

    document.querySelectorAll('[data-filter-link]').forEach(link => {
      link.addEventListener('click', () => {
        const collectionSection = document.querySelector('.main-collection');
        if (collectionSection) {
          setTimeout(() => {
            collectionSection.scrollIntoView({behavior: 'smooth', block: 'start'});
          }, 100);
        }
      });
    });

    if (window.location.hash) {
      const filter = window.location.hash.replace('#', '');
      const filterPill = document.querySelector(`.product-line-filter[data-filter="${filter}"]`);
      if (filterPill) {
        setTimeout(() => filterPill.click(), 100);
      }
    }

    // Sort dropdown handler
    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function(e) {
        const sortValue = e.target.value;
        const url = new URL(window.location.href);
        
        if (sortValue && sortValue !== 'manual') {
          url.searchParams.set('sort_by', sortValue);
        } else {
          url.searchParams.delete('sort_by');
        }
        
        // Reset to first page when sorting
        url.searchParams.delete('page');
        
        window.location.href = url.toString();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollection);
  } else {
    initializeCollection();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const banner = document.querySelector('.products-banner');
    if (! banner) return;
    


    const disableDynamic = banner.dataset.disableDynamic === 'true';
    const collectionsBase = (banner.dataset.collectionsBase || '/collections').replace(/\/$/, '');


// Function to switch banners
    function switchBanner(type) {
      const defaultBanner = banner.querySelector('.default-banner');
      const allBanners = () => banner.querySelectorAll('.default-banner, .dynamic-banner');

      const hideAll = () => {
        allBanners().forEach(b => b.style.display = 'none');
      };

// When dynamic banners are disabled, always show the default cards
      if (disableDynamic) {
        hideAll();
        if (defaultBanner) {
          defaultBanner.style.display = 'flex';
        }
        return;
      }

// Hide all banners before showing the requested one
      hideAll();

// Show the appropriate banner
      if (type === 'all' || ! type) {
        if (defaultBanner) {
          defaultBanner.style.display = 'flex';
        }
      } else {
        const dynamicBanner = banner.querySelector(`[data-banner-type="${type}"]`);
        if (dynamicBanner) {
          dynamicBanner.style.display = 'flex';
        } else if (defaultBanner) {
          defaultBanner.style.display = 'flex';
        }
      }
    }

// Handle clicks on tiles in the default banner - navigate to collections
    const tiles = banner.querySelectorAll('.product-tile[data-filter-trigger]');
    tiles.forEach(tile => {
      tile.addEventListener('click', function(e) {
        e.preventDefault();
        const filterType = this.dataset.filterTrigger;
        const normalizedBase = collectionsBase || '';
        const getCollectionUrl = handle => {
          if (!handle) {
            return banner.dataset.allProductsUrl || `${normalizedBase}/all`;
          }
          const base = normalizedBase.endsWith('/')
            ? normalizedBase.slice(0, -1)
            : normalizedBase;
          return `${base}/${handle}`;
        };

// Navigate to the appropriate collection (respect locale prefix)
        if (filterType === 'ayla-delight') {
          window.location.href = getCollectionUrl('ayla-delight');
        } else if (filterType === 'ayla-help') {
          window.location.href = getCollectionUrl('ayla-help');
        } else if (filterType === 'ayla-rescue') {
          window.location.href = getCollectionUrl('ayla-rescue');
        }
      });
    });

    function resolveBannerType(detail) {
      if (! detail) {
        return null;
      }

      if (detail.bannerType) {
        return detail.bannerType;
      }

      return detail.filter || null;
    }

// Listen for filter changes from the collection
    document.addEventListener('collection-filter-change', function(e) {
      const targetBanner = resolveBannerType(e.detail);
      switchBanner(targetBanner || 'all');
    });

// Set initial banner based on data attribute
    const initialBanner = banner.dataset.initialBanner || 'all';

// Only switch if not already set by Liquid
    if (initialBanner && initialBanner !== 'all') {
      switchBanner(initialBanner);
    }

    // Temporary: Handle responsive banner images for default banner (now using img tags, handled by CSS)
    // No JavaScript needed - CSS media queries handle the switching
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0; // Track which original card is in the spotlight
      this.totalSlides = parseInt(this.dataset.totalSlides) || 1;
      this.autoplayEnabled = false; // Disable autoplay to prevent rapid shuffling
      const rawAutoplayDelay = Number(this.dataset.autoplayDelay);
      this.autoplayDelay = Number.isFinite(rawAutoplayDelay) && rawAutoplayDelay > 0
        ? rawAutoplayDelay * 1000
        : 6000;
      this.autoplayTimer = null;
      this.isAnimating = false;
      this.isStaticDisplay = false;
      this.mode = null;
      this.eventsBound = false;
      this.track = this.querySelector('.testimonials-track');
      this.cards = Array.from(this.querySelectorAll('.testimonial-card'));
      this.cardTemplates = this.cards.map((card) => card.cloneNode(true));
      this.totalSlides = this.cardTemplates.length || this.totalSlides;
      this.prevButton = this.querySelector('.nav-prev');
      this.nextButton = this.querySelector('.nav-next');
      this.navigationWrapper = this.querySelector('.testimonials-navigation');

      this.handleResize = this.handleResize.bind(this);
      this.resizeRaf = null;

      this.init();
    }

    connectedCallback() {
      window.addEventListener('resize', this.handleResize);
      this.setAttribute('tabindex', '0');
      this.setAttribute('role', 'region');
      this.setAttribute('aria-label', 'Testimonials carousel');
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      if (this.resizeRaf) {
        cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = null;
      }
      this.stopAutoplay();
    }

    init() {
      this.configureLayoutMode(true);
      window.debugTestimonials = () => this.debugCardStates();
    }

    debugCardStates() {
      console.log('=== TESTIMONIALS DEBUG ===');
      console.log('Total slides:', this.totalSlides);
      console.log('Current trackPosition:', this.trackPosition);
      console.log('Active Index:', this.activeIndex);

      if (!this.allCards || !this.allCards.length) {
        console.log('Carousel inactive - static layout in use');
        return 'Static layout active';
      }

// Check each card
      this.allCards.forEach((card, index) => {
        const isExpert = card.classList.contains('expert-card');
        const isActive = card.classList.contains('is-active');
        const originalIndex = card.dataset.originalIndex;
        const cloneSet = card.dataset.cloneSet;
        const computedBg = window.getComputedStyle(card).backgroundColor;

        if (isActive) {
          console.log(`Card ${index}: [ACTIVE] ${
            isExpert
              ? 'EXPERT'
              : 'CLIENT'
            } | Original: ${originalIndex} | Set: ${cloneSet} | BG: ${computedBg}`);
        }
      });

// Check CSS variable
      const rootStyles = getComputedStyle(document.documentElement);
      console.log('--primary-p700 value:', rootStyles.getPropertyValue('--primary-p700') || 'NOT FOUND');

      return 'Debug complete - check console';
    }

    configureLayoutMode(force = false) {
      const shouldUseStatic = this.shouldUseStaticLayout();

      if (shouldUseStatic) {
        if (force || this.mode !== 'static') {
          this.enableStaticMode();
        } else {
          this.updateStaticDisplay();
        }
      } else {
        if (force || this.mode !== 'carousel') {
          this.enableCarouselMode();
        } else {
          this.updateDisplay(true);
        }
      }
    }

    shouldUseStaticLayout() {
      if (this.totalSlides<= 3) {
        this.resetCardDimensions();
        return true;
      }

      this.resetCardDimensions();
      return false;
    }

    enableStaticMode() {
      this.stopAutoplay();
      this.mode = 'static';
      this.isStaticDisplay = true;
      this.teardownCarousel();
      this.renderOriginalCards();
      this.trackPosition = 0;
      this.activeIndex = 0;
      this.setNavigationVisibility(false);
      this.setupStaticDisplay();
    }

    enableCarouselMode() {
      this.mode = 'carousel';
      this.isStaticDisplay = false;
      this.resetCardDimensions();
      this.renderOriginalCards();
      this.setupCarousel();
      this.setNavigationVisibility(this.totalSlides> 1) 


        if (!this.eventsBound) {
          this.setupEventListeners();
          this.setupAutoplayControls();
          this.eventsBound = true;
        }
      


      if (this.autoplayEnabled) {
        this.startAutoplay();
      }
    }

    renderOriginalCards() {
      if (!this.track) return;
      


      this.track.innerHTML = '';
      this.cardTemplates.forEach((template) => {
        const clone = template.cloneNode(true);
        this.track.appendChild(clone);
      });

      this.cards = Array.from(this.track.querySelectorAll('.testimonial-card'));
    }

    teardownCarousel() {
      this.allCards = [];
      if (this.track) {
        this.track.style.transition = '';
      }
    }

    setNavigationVisibility(show) {
      if (!this.navigationWrapper) return;
      


      if (show) {
        this.navigationWrapper.classList.remove('is-hidden');
        this.navigationWrapper.setAttribute('aria-hidden', 'false');
      } else {
        this.navigationWrapper.classList.add('is-hidden');
        this.navigationWrapper.setAttribute('aria-hidden', 'true');
      }
    }

    resetCardDimensions() {
      this.style.removeProperty('--card-width');
      this.style.removeProperty('--card-height');
    }

    setupStaticDisplay() {
      const middleIndex = Math.floor(this.totalSlides / 2);
      this.cards.forEach((card, index) => {
        card.classList.remove('is-active', 'is-side', 'is-far');
        if (index === middleIndex) {
          card.classList.add('is-active');
        }
      });

      this.updateStaticDisplay();
    }

    updateStaticDisplay() {
      if (!this.track) return;
      


      const carouselEl = this.querySelector('.testimonials-carousel');
      if (! carouselEl) return;
      


      const carouselWidth = carouselEl.offsetWidth;
      if (! carouselWidth) return;
      


      const trackWidth = this.track.scrollWidth;
      const translateX = (carouselWidth - trackWidth) / 2;
      this.track.style.transform = `translateX(${translateX}px)`;
    }

    setupCarousel() {

// Create a circular array by cloning cards
      this.allCards = [];
      this.track.innerHTML = '';

// Create a reasonable number of clones for smooth infinite scrolling
// 2 sets before, current set, and 2 sets after = 5 sets total
      const totalSets = 5;
      const middleSet = Math.floor(totalSets / 2);

      for (let i = 0; i < totalSets; i++) {
        this.cardTemplates.forEach((template, index) => {
          const clone = template.cloneNode(true);
          clone.dataset.originalIndex = index;
          clone.dataset.cloneSet = i;
          clone.classList.remove('is-active', 'is-side', 'is-far');
          this.allCards.push(clone);
          this.track.appendChild(clone);
        });
      }

// Start in the middle of all sets
      this.trackPosition = middleSet * this.totalSlides;

      this.updateDisplay();
    }

    updateDisplay(skipActiveUpdate = false) {
      if (!this.track) return;
      


      const carouselEl = this.querySelector('.testimonials-carousel');
      const activeCard = this.allCards
        ? this.allCards[this.trackPosition]
        : null;

      if (! carouselEl || ! activeCard) {
        return;
      }

      const carouselRect = carouselEl.getBoundingClientRect();
      const activeRect = activeCard.getBoundingClientRect();
      const currentTranslate = this.getCurrentTranslateX();
      const carouselCenter = carouselRect.left + (carouselRect.width / 2);
      const activeCenter = activeRect.left + (activeRect.width / 2);
      const delta = carouselCenter - activeCenter;
      const translateX = currentTranslate + delta;

      this.track.style.transform = `translateX(${translateX}px)`;

// Skip active state updates during position resets
      if (skipActiveUpdate) return;
      


      this.updateCardStates();
    }

    updateCardStates() {
      if (!this.allCards || !this.allCards.length) return;
      


      this.allCards.forEach((card, index) => {
        card.classList.remove('is-active', 'is-side', 'is-far');

        if (index === this.trackPosition) {
          card.classList.add('is-active');
        } else if (index === this.trackPosition - 1 || index === this.trackPosition + 1) {
          card.classList.add('is-side');
        } else if (index === this.trackPosition - 2 || index === this.trackPosition + 2) {
          card.classList.add('is-far');
        }
      });
    }

    getCurrentTranslateX() {
      if (!this.track) 
        return0;
      


      const computedStyle = window.getComputedStyle(this.track);
      const transform = computedStyle.transform;

      if (! transform || transform === 'none') 
        return0;
      


      if (transform.startsWith('matrix3d')) {
        const values = transform.slice(9, -1).split(',').map(parseFloat);
        return values[12] || 0;
      }

      if (transform.startsWith('matrix')) {
        const values = transform.slice(7, -1).split(',').map(parseFloat);
        return values[4] || 0;
      }

      return 0;
    }

    handleResize() {
      if (this.resizeRaf) {
        cancelAnimationFrame(this.resizeRaf);
      }

      this.resizeRaf = requestAnimationFrame(() => {
        this.configureLayoutMode();
      });
    }

    nextSlide() {
      if (this.isAnimating) return;
      


      if (!this.allCards || !this.allCards.length) return;
      


      this.isAnimating = true;

// Move to next position
      this.trackPosition ++;
      this.activeIndex = (this.activeIndex + 1) % this.totalSlides;

// Animate the transition
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      this.updateDisplay();

// Check if we need to reset position (wrap around)
// Reset when we're getting close to the end
      const totalCards = this.allCards.length;
      const resetThreshold = totalCards - this.totalSlides * 2;

      if (this.trackPosition >= resetThreshold) {
        setTimeout(() => {
          this.classList.add('is-resetting');
          this.track.style.transition = 'none';
          this.trackPosition = this.totalSlides * 2; // Reset to near beginning
          this.updateDisplay();
          requestAnimationFrame(() => {
            this.track.style.transition = '';
            this.classList.remove('is-resetting');
          });
        }, 500);
      }

// After animation completes
      setTimeout(() => {
        this.isAnimating = false;
      }, 500);

      this.resetAutoplay();
    }

    prevSlide() {
      if (this.isAnimating) return;
      


      if (!this.allCards || !this.allCards.length) return;
      


      this.isAnimating = true;

// Move to previous position
      this.trackPosition --;
      this.activeIndex = (this.activeIndex - 1 + this.totalSlides) % this.totalSlides;

// Animate the transition
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      this.updateDisplay();

// Check if we need to reset position (wrap around)
// Reset when we're getting close to the beginning
      const resetThreshold = this.totalSlides;

      if (this.trackPosition<= resetThreshold) {
        setTimeout(() => {
        this.classList.add('is-resetting');
        this.track.style.transition = 'none';
        this.trackPosition = this.allCards.length - this.totalSlides * 2; // Reset to near end
        this.updateDisplay();
        requestAnimationFrame(() => {
          this.track.style.transition = '';
          this.classList.remove('is-resetting');
        });
      }, 500) 


      


    }

// After animation completes
    setTimeout(() => {
      this.isAnimating = false;
    }, 500);

    this.resetAutoplay();
  }

  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }

// Keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
      }
    });

// Touch support
    let startX = null;
    let currentX = null;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, {passive: true});

    this.track.addEventListener('touchmove', (e) => {
      if (! startX) return;
      


      currentX = e.touches[0].clientX;
    }, {passive: true});

    this.track.addEventListener('touchend', () => {
      if (! startX || ! currentX) return;
      


      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }

      startX = null;
      currentX = null;
    });
  }

  setupAutoplayControls() {
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => {
      if (this.autoplayEnabled) 
        this.startAutoplay();
      


    });

    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => {
      if (this.autoplayEnabled) 
        this.startAutoplay();
      


    });
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.totalSlides<= 3) return;
      
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
      if (!this.isAnimating) {
        this.nextSlide();
      }
    }, this.autoplayDelay) 


    


  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {

// Autoplay intentionally disabled in carousel mode per UX request
  }

}

customElements.define('testimonials-section', TestimonialsSection);

  } catch(e) { console.error(e); }
})();
})();
